<template>
    <b-row class="primary-nav" no-gutters="true">
        <b-col><router-link class="nav-link" to="/">HOME</router-link></b-col>
        <b-col><router-link class="nav-link" to="/releases">RELEASES</router-link></b-col>
        <b-col><router-link class="nav-link" to="/schedule">SCHEDULE</router-link></b-col>
        <b-col><router-link class="nav-link" to="/podcasts">PODCASTS</router-link></b-col>
        <b-col><router-link class="nav-link" to="/chat">CHAT</router-link></b-col>
    </b-row>
</template>

<script>
export default {

}
</script>

<style>

@import url(https://fonts.googleapis.com/css?family=Share:400,700&subset=latin,latin-ext);

.no-gutters {
  margin-right: -15px;
  margin-left: -15px;
}

.primary-nav {
    background-color: rgba(0, 0, 0, 0.75);
}

.primary-nav div {
  text-align: center;
}

.primary-nav a {
    color: #fff;
    text-decoration: none;
    border-right: 1px solid #000;
    font-family: Share, Helvetica, Arial, sans-serif;
    font-weight: 400;
    font-size: 1.25rem;
}

.primary-nav a:hover,
.primary-nav .router-link-exact-active {
    color: black;
    background: #bf2026;
}


@media (min-width: 576px) {
	.primary-nav a  {
		font-size: 1.5rem;
	}
}

@media (min-width: 768px) {
	.primary-nav a  {
		font-size: 1.75rem;
	}
}

@media (min-width: 992px) {
	.primary-nav a  {
		font-size: 2rem;
	}
}

@media (min-width: 1200px) {
	.primary-nav a  {
		font-size: 2.25rem;
	}
}

</style>



// WEBPACK FOOTER //
// src/components/NavigationBar.vue